(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["region-manufacturer-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('region-manufacturer-details')) {
  customElements.define('region-manufacturer-details', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[data-mfr-tab]')];
      this.panels = [...this.querySelectorAll('[data-mfr-panel]')];
      if (!this.tabs.length) return;
      this.addEventListener('click', event => {
        const target = event.target.closest('[data-mfr-tab],[data-mfr-open]');
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        const panel = this.open(target.dataset.mfrTab || target.dataset.mfrOpen);
        if (target.dataset.mfrOpen && panel) { panel.focus({preventScroll:true}); panel.scrollIntoView({block:'start'}); }
      }, options);
      this.querySelector('[role="tablist"]').addEventListener('keydown', event => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.open(this.tabs[index].dataset.mfrTab);
        this.tabs[index].focus();
      }, options);
      this.open(this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true')?.dataset.mfrTab || this.tabs[0].dataset.mfrTab);
    }
    open(name) {
      const panel = this.panels.find(item => item.dataset.mfrPanel === name);
      if (!panel) return;
      this.tabs.forEach(tab => { const active = tab.dataset.mfrTab === name; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      this.panels.forEach(item => { item.hidden = item !== panel; });
      return panel;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["region-mobile-columns-collection"]) return;
  try {
    
function initRegionMobileColumns(scope) {
  scope.querySelectorAll('.rc-mobile-columns').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.rc-filters');
    const drawer = root.querySelector('.rc-filter-drawer');
    if (drawer && matchMedia('(max-width:899px)').matches) drawer.open = false;
    if (form) {
      form.addEventListener('submit', event => {
        event.preventDefault();
        const url = new URL(form.action);
        for (const [key, value] of new FormData(form)) {
          if (String(value).trim() !== '') url.searchParams.append(key, value);
        }
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.hash = 'RegionResults';
        location.assign(url.href);
      });
      const sort = root.querySelector('select[name="sort_by"]');
      if (sort) sort.addEventListener('change', () => form.requestSubmit());
    }
    root.querySelectorAll('.rc-tag-link a').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      const url = new URL(link.href);
      const query = new URLSearchParams(location.search);
      query.delete('page');
      url.search = query.toString();
      url.hash = 'RegionResults';
      location.assign(url.href);
    }));
  });
}
initRegionMobileColumns(document);
document.addEventListener('shopify:section:load', event => initRegionMobileColumns(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["region-product-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  if (!event.target.matches('[data-pks-product-configuration]')) return;
  const url = new URL(event.target.value, location.origin);
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  if (preview) url.searchParams.set('preview_theme_id', preview);
  location.assign(url.href);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["region-rockzone-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('region-rockzone-details')) {
  customElements.define('region-rockzone-details', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[data-rock-tab]')];
      this.panels = [...this.querySelectorAll('[data-rock-panel]')];
      if (!this.tabs.length) return;
      this.addEventListener('click', event => {
        const target = event.target.closest('[data-rock-tab],[data-rock-open]');
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        const panel = this.open(target.dataset.rockTab || target.dataset.rockOpen);
        if (target.dataset.rockOpen && panel) { panel.focus({preventScroll:true}); panel.scrollIntoView({block:'start'}); }
      }, options);
      this.querySelector('[role="tablist"]').addEventListener('keydown', event => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.open(this.tabs[index].dataset.rockTab);
        this.tabs[index].focus();
      }, options);
      this.open(this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true')?.dataset.rockTab || this.tabs[0].dataset.rockTab);
    }
    open(name) {
      const panel = this.panels.find(item => item.dataset.rockPanel === name);
      if (!panel) return;
      this.tabs.forEach(tab => { const active = tab.dataset.rockTab === name; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      this.panels.forEach(item => { item.hidden = item !== panel; });
      return panel;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["region-shop-equipment-collection"]) return;
  try {
    
function initRegionShopCollection(scope) {
  scope.querySelectorAll('.rc-shop-collection').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.rc-filters');
    const drawer = root.querySelector('.rc-filter-drawer');
    if (drawer && matchMedia('(max-width:899px)').matches) drawer.open = false;
    if (form) {
      form.addEventListener('submit', event => {
        event.preventDefault();
        const url = new URL(form.action);
        for (const [key, value] of new FormData(form)) {
          if (String(value).trim() !== '') url.searchParams.append(key, value);
        }
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.hash = 'RegionResults';
        location.assign(url.href);
      });
      const sort = root.querySelector('select[name="sort_by"]');
      if (sort) sort.addEventListener('change', () => form.requestSubmit());
    }
    root.querySelectorAll('.rc-tag-link a').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      const url = new URL(link.href);
      const query = new URLSearchParams(location.search);
      query.delete('page');
      url.search = query.toString();
      url.hash = 'RegionResults';
      location.assign(url.href);
    }));
  });
}
initRegionShopCollection(document);
document.addEventListener('shopify:section:load', event => initRegionShopCollection(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSbcSlider(section) {
      var track = section.querySelector('[data-sbc-track]');
      var prevBtn = section.querySelector('[data-sbc-prev]');
      var nextBtn = section.querySelector('[data-sbc-next]');
      if (!track || !prevBtn || !nextBtn) return;

      var sliderD = section.dataset.sliderDesktop === 'true';
      var sliderT = section.dataset.sliderTablet === 'true';
      var sliderM = section.dataset.sliderMobile === 'true';

      function isSliderActive() {
        var w = window.innerWidth;
        if (w >= 990) return sliderD;
        if (w >= 750) return sliderT;
        return sliderM;
      }

      function updateNavVisibility() {
        if (!isSliderActive()) {
          prevBtn.hidden = true;
          nextBtn.hidden = true;
          return;
        }
        // Show only when content actually overflows
        var canScroll = track.scrollWidth > track.clientWidth + 4;
        prevBtn.hidden = !canScroll;
        nextBtn.hidden = !canScroll;
        if (canScroll) updateNavState();
      }

      function updateNavState() {
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        prevBtn.classList.toggle('is-disabled', atStart);
        nextBtn.classList.toggle('is-disabled', atEnd);
        prevBtn.setAttribute('aria-disabled', atStart);
        nextBtn.setAttribute('aria-disabled', atEnd);
      }

      function getStep() {
        // Scroll by one tile width + gap
        var firstTile = track.querySelector('.sbc-tile');
        if (!firstTile) return track.clientWidth * 0.8;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0');
        return firstTile.getBoundingClientRect().width + gap;
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateNavState, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateNavVisibility, 150);
      });

      // Initial check (after layout settles)
      requestAnimationFrame(updateNavVisibility);
      // One more tick for image loads
      window.addEventListener('load', updateNavVisibility, { once: true });
    }

    document.querySelectorAll('[data-sbc-slider]').forEach(initSbcSlider);

    // Re-init on theme editor changes
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-sbc-slider]');
      if (section) initSbcSlider(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
